var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconJobsDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f78f28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f26341"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,9A4,4,0,1,1,9,5,4,4,0,0,1,5,9ZM5,3A2,2,0,1,0,7,5,2,2,0,0,0,5,3Z",
    fill: "#1a1b43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,29a4,4,0,1,1,4-4A4,4,0,0,1,9,29Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,9,23Z",
    fill: "#1a1b43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7,19a4,4,0,1,1,4-4A4,4,0,0,1,7,19Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,7,13Z",
    fill: "#1a1b43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H13a1,1,0,0,1,0-2H25a1,1,0,0,1,0,2Z",
    fill: "url(#a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27,16H15a1,1,0,0,1,0-2H27a1,1,0,0,1,0,2Z",
    fill: "#1a1b43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26H17a1,1,0,0,1,0-2H29a1,1,0,0,1,0,2Z",
    fill: "#1a1b43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJobsDark);
export default __webpack_public_path__ + "static/media/icon-jobs-dark.17b84a8a.svg";
export { ForwardRef as ReactComponent };